import { FuseNavigationItem } from '@fuse/components/navigation';

export default function SalesAdvisorNav() {

    const nav: FuseNavigationItem[] = [
        {
            id:'accounting',
            title: 'Contabilidad',
            subtitle: 'Administra todos los ejercicios contables',
            type: 'group',
            icon: 'heroicons_outline:banknotes',
            children:
            [
                {
                    id: 'accounting.pos',
                    title: 'POS',
                    type: 'basic',
                    icon: 'heroicons_outline:building-storefront',
                    link: '/accounting/pos'
                },
                {
                    id: 'accounting.quotations',
                    title: 'Cotizaciones',
                    type: 'basic',
                    icon: 'heroicons_outline:document-minus',
                    link: '/accounting/quotations'
                },
                {
                    id: 'accounting.invoices',
                    title: 'Facturas',
                    type: 'basic',
                    icon: 'heroicons_outline:document-text',
                    link: '/accounting/invoices'
                },
                {
                    id: 'accounting.dailyClose',
                    title: 'Cierres Diarios',
                    type: 'basic',
                    icon: 'heroicons_outline:banknotes',
                    link: '/accounting/daily-closes'
                },
            ]
        },
        {
            id: 'crm',
            title: 'CRM',
            subtitle: 'Interactua con los clientes',
            type: 'group',
            icon: 'heroicons_outline:home',
            children: [
                {
                    id: 'dashboard',
                    title: 'Dashboard',
                    type: 'basic',
                    icon: 'heroicons_outline:chart-pie',
                    link: '/dashboard/advisor'
                },
                {
                    id: 'crm.clientes',
                    title: 'Clientes',
                    type: 'basic',
                    icon: 'heroicons_outline:users',
                    link: '/crm/customers'
                },
                {
                    id: 'crm.leads.myDay',
                    title: 'Mi día',
                    type: 'basic',
                    icon: 'heroicons_outline:clock',
                    link: '/crm/leads/hoy'
                },
                {
                    id: 'crm.leads.board',
                    title: 'Pipeline de leads',
                    type: 'basic',
                    icon: 'heroicons_outline:view-grid',
                    link: '/crm/leads'
                },
                {
                    id: 'activities',
                    title: 'Calendario de Actividades',
                    type: 'basic',
                    icon: 'heroicons_outline:calendar',
                    link: '/crm/activities'
                },
            ],
        },
        {
            id: 'inventory',
            title: 'Inventario',
            subtitle: 'Administra los productos y proveedores',
            type: 'group',
            icon: 'heroicons_outline:home',
            children: [
                {
                    id: 'inventory.brochure',
                    title: 'Brochures',
                    type: 'basic',
                    icon: 'heroicons_outline:document-arrow-down',
                    link: '/inventory/brochure'
                },
                {
                    id: 'inventory.products',
                    title: 'Productos',
                    type: 'basic',
                    icon: 'heroicons_outline:shopping-bag',
                    link: '/inventory/products'
                },
            ]
        }
    ];

    return nav;
}